import { render } from "./legend-key-value.vue?vue&type=template&id=05021a86&scoped=true"
import script from "./legend-key-value.vue?vue&type=script&lang=js"
export * from "./legend-key-value.vue?vue&type=script&lang=js"

import "./legend-key-value.vue?vue&type=style&index=0&id=05021a86&lang=scss&scoped=true"

import exportComponent from "c:\\jenkins\\workspace\\Client_Windows_build\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05021a86"]])

export default __exports__